import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { config } from '../../common/';
import * as Subscription from '../../subscription';

const BaseLayout: React.FC<{}> = () => {
    return (
        <Route
            render={() => {
                return (
                    <React.Fragment>
                        <Switch>
                            <Route exact path={[`${config.BaseURL}/subscription/packs`, `${config.AlternativeBaseURL}/subscription/packs`]} component={Subscription.PacksLayout} />
                            {/*<Route exact path={[`${config.BaseURL}/subscription/updatepaymentsource`, `${config.AlternativeBaseURL}/subscription/updatepaymentsource`]} component={Subscription.ChangePaymentDetails} />*/}
                            <Route path={[`${config.BaseURL}/subscription/details/:planId/:vehcode`, `${config.AlternativeBaseURL}/subscription/details/:planId/:vehcode`]} component={Subscription.ShowDetails} />
                            <Route path={[`${config.BaseURL}/subscription/createconfirm/:planName/:vehcode`, `${config.AlternativeBaseURL}/subscription/createconfirm/:planName/:vehcode`]} component={Subscription.CreateConfirm} />
                            <Route path={[`${config.BaseURL}/subscription/cancelconfirm/:planName/:vehcode`, `${config.AlternativeBaseURL}/subscription/cancelconfirm/:planName/:vehcode`]} component={Subscription.CancelConfirm} />
                        </Switch>
                    </React.Fragment>
                );
            }}
        />
    );
};

export default BaseLayout;
